import DeviceConnectedSuccessfullyImage from "../../assets/images/account-steps-completed-tick.svg";
import ErrorPage from "../shared/errorPage/ErrorPage";
import Loader from "../shared/loader/Loader";
import "./LoaderSuccessMessagesInPopup.css";

const AlertMessages = ( { Response ,successMsg, showLoader = true} ) => {

    return(
        (Response?.error)
       ? <div className="add-device-device-config-success-wrapper device-not-connected-wrapper overlay-parent"> 
                    <div className='spinner-wrapper apply-overlay-bg device-successfully-connected'>
                      <ErrorPage errorInfo={Response.error} webConnectionDashboardError={true}/>
                    </div>
                  </div>
        : <>
              { 
                (Response?.loading && showLoader)
                &&
                  <div className="device-not-connected-wrapper">
                    <div className={`add-device-device-config loader-overlay-wrapper`}>
                      <Loader webConnection={true} setOverlay={true}></Loader>
                    </div>
                  </div> 
              }
              {
                (Response?.success)
                && 
                <div className="add-device-device-config-success-wrapper device-not-connected-wrapper overlay-parent"> 
                    <div className='spinner-wrapper apply-overlay-bg device-successfully-connected'>
                      <img src={DeviceConnectedSuccessfullyImage} alt="device-successfully-connected"></img>
                      <div>{successMsg}</div>
                    </div>
                  </div>
              }
          </>
                     
    )
}

export default AlertMessages;
